module.exports = __webpack_public_path__ + "img/m_section_6_bg_2.5b2f20b8.png";